/* SCRIB3D — Shopify テーマ用 軽量インタラクション
   ※ 複数セクションから読み込まれても一度だけ初期化されるようガード。
   ※ Shopify テーマエディタでの再描画にも追従。 */
(function () {
  "use strict";

  function initReveal(root) {
    var reveals = (root || document).querySelectorAll(".scrib3d .reveal:not(.is-bound)");
    if (!reveals.length) return;
    if (!("IntersectionObserver" in window)) {
      reveals.forEach(function (el) { el.classList.add("is-in", "is-bound"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    reveals.forEach(function (el, i) {
      el.classList.add("is-bound");
      el.style.transitionDelay = (i % 4) * 0.08 + "s";
      io.observe(el);
    });
  }

  /* ブランドムービー: フレーム形状を PC=横(16:9) / スマホ=縦(9:16) に */
  function applyMovieRatio() {
    var isMobile = window.matchMedia("(max-width: 768px)").matches;
    document.querySelectorAll(".scrib3d-movie .movie__frame").forEach(function (frame) {
      if (frame.getAttribute("data-has-vertical") === "true") {
        frame.classList.toggle("is-vertical", isMobile);
      }
    });
  }

  /* iframe の src に自動再生（ミュート・ループ）パラメータを付与 */
  function withAutoplay(src, controls) {
    try {
      var u = new URL(src, window.location.href);
      if (/youtube|youtu\.be/.test(u.hostname)) {
        var id = u.pathname.split("/").pop();
        u.searchParams.set("autoplay", "1");
        u.searchParams.set("mute", "1");
        u.searchParams.set("loop", "1");
        u.searchParams.set("playlist", id);
        u.searchParams.set("playsinline", "1");
        u.searchParams.set("rel", "0");
        u.searchParams.set("modestbranding", "1");
        u.searchParams.set("controls", controls ? "1" : "0");
      } else if (/vimeo/.test(u.hostname)) {
        u.searchParams.set("autoplay", "1");
        u.searchParams.set("muted", "1");
        u.searchParams.set("loop", "1");
        u.searchParams.set("background", controls ? "0" : "1");
      } else {
        u.searchParams.set("autoplay", "1");
        u.searchParams.set("mute", "1");
      }
      return u.toString();
    } catch (e) { return src; }
  }

  /* 選んだテンプレート（横/縦）をプレイヤーに差し込んで再生 */
  function injectEmbed(frame, autoplay) {
    var player = frame.querySelector(".movie__player");
    if (!player) return;
    var isMobile = window.matchMedia("(max-width: 768px)").matches;
    var tplV = frame.querySelector(".movie__embed-v");
    var tplH = frame.querySelector(".movie__embed-h");
    var tpl = (isMobile && tplV) ? tplV : tplH;
    if (!tpl) return;

    var controls = frame.getAttribute("data-controls") === "true";
    var wrap = document.createElement("div");
    wrap.innerHTML = tpl.innerHTML;

    var iframe = wrap.querySelector("iframe");
    var video = wrap.querySelector("video");
    if (iframe) {
      if (autoplay) { iframe.src = withAutoplay(iframe.getAttribute("src"), controls); }
      var allow = iframe.getAttribute("allow") || "";
      if (allow.indexOf("autoplay") === -1) { iframe.setAttribute("allow", (allow ? allow + "; " : "") + "autoplay; fullscreen; picture-in-picture"); }
    }
    if (video && autoplay) {
      video.muted = true; video.loop = true; video.autoplay = true;
      video.setAttribute("playsinline", "");
      if (!controls) { video.removeAttribute("controls"); } else { video.setAttribute("controls", ""); }
    }

    player.innerHTML = wrap.innerHTML;
    frame.classList.add("is-playing");
    frame.setAttribute("data-active", (isMobile && tplV) ? "v" : "h");

    if (video && autoplay) {
      var v = player.querySelector("video");
      if (v && v.play) { var p = v.play(); if (p && p.catch) { p.catch(function () {}); } }
    }
  }

  function initMovies(root) {
    (root || document).querySelectorAll(".scrib3d-movie .movie__frame:not(.is-bound)").forEach(function (frame) {
      frame.classList.add("is-bound");
      var autoplay = frame.getAttribute("data-autoplay") === "true";
      if (autoplay) {
        injectEmbed(frame, true);
      } else {
        var play = frame.querySelector(".play");
        if (play) { play.addEventListener("click", function () { injectEmbed(frame, true); }); }
      }
    });
  }

  /* リサイズで PC↔スマホ をまたいだら、横/縦の動画を差し替え */
  function reswapMovies() {
    var isMobile = window.matchMedia("(max-width: 768px)").matches;
    document.querySelectorAll(".scrib3d-movie .movie__frame.is-playing[data-has-vertical='true']").forEach(function (frame) {
      var want = isMobile ? "v" : "h";
      if (frame.getAttribute("data-active") !== want) {
        injectEmbed(frame, frame.getAttribute("data-autoplay") === "true" || true);
      }
    });
  }

  function initAll(root) {
    initReveal(root);
    initMovies(root);
    applyMovieRatio();
  }

  document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  window.addEventListener("resize", function () { applyMovieRatio(); reswapMovies(); });
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
})();